// extracted by mini-css-extract-plugin
export default {"tooltip":"bW-z","arrow":"cW-z"};